module.exports = __webpack_public_path__ + "static/media/m-penguin-homecomming.628c1c64.png";